import * as l from "react";
import { createContext as de, useContext as re } from "react";
import { w as Rt, q as A, W as It, X as Lt, Y as Wt, Z as Ft, R as ue, _ as K, Q as Yt, t as Kt, $ as F, s as ne, j as fe, a0 as zt, a1 as qt, a2 as oe, a3 as me, a4 as Ut, C as B, a5 as ge, a6 as Bt, a7 as ae, a8 as Gt, a9 as Ht, aa as Qt, e as Xt } from "./CSSMotionList.js";
import { d as D, w as R, I as Zt, W as Jt } from "./warning.js";
import { S as G, a as er } from "./omit.js";
function tr(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = /* @__PURE__ */ new Set();
  function i(c, o) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, d = n.has(c);
    if (Rt(!d, "Warning: There may be circular references"), d)
      return !1;
    if (c === o)
      return !0;
    if (r && s > 1)
      return !1;
    n.add(c);
    var a = s + 1;
    if (Array.isArray(c)) {
      if (!Array.isArray(o) || c.length !== o.length)
        return !1;
      for (var f = 0; f < c.length; f++)
        if (!i(c[f], o[f], a))
          return !1;
      return !0;
    }
    if (c && o && A(c) === "object" && A(o) === "object") {
      var p = Object.keys(c);
      return p.length !== Object.keys(o).length ? !1 : p.every(function(b) {
        return i(c[b], o[b], a);
      });
    }
    return !1;
  }
  return i(t, e);
}
function rr(t) {
  return It(t) || Lt(t) || Wt(t) || Ft();
}
function z(t, e) {
  for (var r = t, n = 0; n < e.length; n += 1) {
    if (r == null)
      return;
    r = r[e[n]];
  }
  return r;
}
function pe(t, e, r, n) {
  if (!e.length)
    return r;
  var i = rr(e), c = i[0], o = i.slice(1), s;
  return !t && typeof c == "number" ? s = [] : Array.isArray(t) ? s = ue(t) : s = K({}, t), n && r === void 0 && o.length === 1 ? delete s[c][o[0]] : s[c] = pe(s[c], o, r, n), s;
}
function Y(t, e, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return e.length && n && r === void 0 && !z(t, e.slice(0, -1)) ? t : pe(t, e, r, n);
}
function nr(t) {
  return A(t) === "object" && t !== null && Object.getPrototypeOf(t) === Object.prototype;
}
function se(t) {
  return Array.isArray(t) ? [] : {};
}
var or = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function ar() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  var n = se(e[0]);
  return e.forEach(function(i) {
    function c(o, s) {
      var d = new Set(s), a = z(i, o), f = Array.isArray(a);
      if (f || nr(a)) {
        if (!d.has(a)) {
          d.add(a);
          var p = z(n, o);
          f ? n = Y(n, o, []) : (!p || A(p) !== "object") && (n = Y(n, o, se(a))), or(a).forEach(function(b) {
            c([].concat(ue(o), [b]), d);
          });
        }
      } else
        n = Y(n, o, a);
    }
    c([]);
  }), n;
}
const sr = /* @__PURE__ */ de(void 0);
var ir = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, lr = {
  yearFormat: "YYYY",
  dayFormat: "D",
  cellMeridiemFormat: "A",
  monthBeforeYear: !0
}, cr = K(K({}, lr), {}, {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  week: "Week",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  dateFormat: "M/D/YYYY",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
});
const ve = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, ie = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, cr),
  timePickerLocale: Object.assign({}, ve)
}, v = "${label} is not a valid ${type}", I = {
  locale: "en",
  Pagination: ir,
  DatePicker: ie,
  TimePicker: ve,
  Calendar: ie,
  global: {
    placeholder: "Please select",
    close: "Close"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckAll: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: v,
        method: v,
        array: v,
        object: v,
        number: v,
        date: v,
        boolean: v,
        integer: v,
        float: v,
        regexp: v,
        email: v,
        url: v,
        hex: v
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty",
    transparent: "Transparent",
    singleColor: "Single",
    gradientColor: "Gradient"
  }
};
let N = Object.assign({}, I.Modal), V = [];
const le = () => V.reduce((t, e) => Object.assign(Object.assign({}, t), e), I.Modal);
function dr(t) {
  if (t) {
    const e = Object.assign({}, t);
    return V.push(e), N = le(), () => {
      V = V.filter((r) => r !== e), N = le();
    };
  }
  N = Object.assign({}, I.Modal);
}
function Mr() {
  return N;
}
const be = /* @__PURE__ */ de(void 0), he = "internalMark", Ce = (t) => {
  const {
    locale: e = {},
    children: r,
    _ANT_MARK__: n
  } = t;
  if (process.env.NODE_ENV !== "production") {
    const c = D("LocaleProvider");
    process.env.NODE_ENV !== "production" && c(n === he, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  l.useEffect(() => dr(e == null ? void 0 : e.Modal), [e]);
  const i = l.useMemo(() => Object.assign(Object.assign({}, e), {
    exist: !0
  }), [e]);
  return /* @__PURE__ */ l.createElement(be.Provider, {
    value: i
  }, r);
};
process.env.NODE_ENV !== "production" && (Ce.displayName = "LocaleProvider");
const ur = `-ant-${Date.now()}-${Math.random()}`;
function fr(t, e) {
  const r = {}, n = (o, s) => {
    let d = o.clone();
    return d = (s == null ? void 0 : s(d)) || d, d.toRgbString();
  }, i = (o, s) => {
    const d = new F(o), a = ne(d.toRgbString());
    r[`${s}-color`] = n(d), r[`${s}-color-disabled`] = a[1], r[`${s}-color-hover`] = a[4], r[`${s}-color-active`] = a[6], r[`${s}-color-outline`] = d.clone().setA(0.2).toRgbString(), r[`${s}-color-deprecated-bg`] = a[0], r[`${s}-color-deprecated-border`] = a[2];
  };
  if (e.primaryColor) {
    i(e.primaryColor, "primary");
    const o = new F(e.primaryColor), s = ne(o.toRgbString());
    s.forEach((a, f) => {
      r[`primary-${f + 1}`] = a;
    }), r["primary-color-deprecated-l-35"] = n(o, (a) => a.lighten(35)), r["primary-color-deprecated-l-20"] = n(o, (a) => a.lighten(20)), r["primary-color-deprecated-t-20"] = n(o, (a) => a.tint(20)), r["primary-color-deprecated-t-50"] = n(o, (a) => a.tint(50)), r["primary-color-deprecated-f-12"] = n(o, (a) => a.setA(a.a * 0.12));
    const d = new F(s[0]);
    r["primary-color-active-deprecated-f-30"] = n(d, (a) => a.setA(a.a * 0.3)), r["primary-color-active-deprecated-d-02"] = n(d, (a) => a.darken(2));
  }
  return e.successColor && i(e.successColor, "success"), e.warningColor && i(e.warningColor, "warning"), e.errorColor && i(e.errorColor, "error"), e.infoColor && i(e.infoColor, "info"), `
  :root {
    ${Object.keys(r).map((o) => `--${t}-${o}: ${r[o]};`).join(`
`)}
  }
  `.trim();
}
function mr(t, e) {
  const r = fr(t, e);
  Yt() ? Kt(r, `${ur}-dynamic-theme`) : process.env.NODE_ENV !== "production" && R(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const q = /* @__PURE__ */ l.createContext(!1), gr = ({
  children: t,
  disabled: e
}) => {
  const r = l.useContext(q);
  return /* @__PURE__ */ l.createElement(q.Provider, {
    value: e ?? r
  }, t);
};
function pr() {
  const t = re(q), e = re(G);
  return {
    componentDisabled: t,
    componentSize: e
  };
}
const vr = (t, e) => {
  const [r, n] = fe();
  return zt({
    theme: r,
    token: n,
    hashId: "",
    path: ["ant-design-icons", t],
    nonce: () => e == null ? void 0 : e.nonce,
    layer: {
      name: "antd"
    }
  }, () => [qt(t)]);
}, br = Object.assign({}, l), {
  useId: ce
} = br, hr = () => "", Cr = typeof ce > "u" ? hr : ce;
function yr(t, e, r) {
  var n, i;
  const c = D("ConfigProvider"), o = t || {}, s = o.inherit === !1 || !e ? Object.assign(Object.assign({}, oe), {
    hashed: (n = e == null ? void 0 : e.hashed) !== null && n !== void 0 ? n : oe.hashed,
    cssVar: e == null ? void 0 : e.cssVar
  }) : e, d = Cr();
  if (process.env.NODE_ENV !== "production") {
    const a = o.cssVar || s.cssVar, f = !!(typeof o.cssVar == "object" && (!((i = o.cssVar) === null || i === void 0) && i.key) || d);
    process.env.NODE_ENV !== "production" && c(!a || f, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return me(() => {
    var a, f;
    if (!t)
      return e;
    const p = Object.assign({}, s.components);
    Object.keys(t.components || {}).forEach((P) => {
      p[P] = Object.assign(Object.assign({}, p[P]), t.components[P]);
    });
    const b = `css-var-${d.replace(/:/g, "")}`, O = ((a = o.cssVar) !== null && a !== void 0 ? a : s.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: r == null ? void 0 : r.prefixCls
    }, typeof s.cssVar == "object" ? s.cssVar : {}), typeof o.cssVar == "object" ? o.cssVar : {}), {
      key: typeof o.cssVar == "object" && ((f = o.cssVar) === null || f === void 0 ? void 0 : f.key) || b
    });
    return Object.assign(Object.assign(Object.assign({}, s), o), {
      token: Object.assign(Object.assign({}, s.token), o.token),
      components: p,
      cssVar: O
    });
  }, [o, s], (a, f) => a.some((p, b) => {
    const O = f[b];
    return !tr(p, O, !0);
  }));
}
function Pr(t) {
  const {
    children: e
  } = t, [, r] = fe(), {
    motion: n
  } = r, i = l.useRef(!1);
  return i.current = i.current || n === !1, i.current ? /* @__PURE__ */ l.createElement(Ut, {
    motion: n
  }, e) : e;
}
const ye = /* @__PURE__ */ l.memo(({
  dropdownMatchSelectWidth: t
}) => (D("ConfigProvider").deprecated(t === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null));
process.env.NODE_ENV !== "production" && (ye.displayName = "PropWarning");
const xr = process.env.NODE_ENV !== "production" ? ye : () => null;
var Or = function(t, e) {
  var r = {};
  for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, n = Object.getOwnPropertySymbols(t); i < n.length; i++)
    e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[i]) && (r[n[i]] = t[n[i]]);
  return r;
};
let U = !1;
const Ar = process.env.NODE_ENV !== "production" ? (t) => {
  process.env.NODE_ENV !== "production" && R(!U, t, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
} : (
  /* istanbul ignore next */
  null
), Sr = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
let T, Pe, xe, Oe;
function M() {
  return T || Xt;
}
function Er() {
  return Pe || ge;
}
function wr(t) {
  return Object.keys(t).some((e) => e.endsWith("Color"));
}
const jr = (t) => {
  const {
    prefixCls: e,
    iconPrefixCls: r,
    theme: n,
    holderRender: i
  } = t;
  e !== void 0 && (T = e), r !== void 0 && (Pe = r), "holderRender" in t && (Oe = i), n && (wr(n) ? (process.env.NODE_ENV !== "production" && R(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), mr(M(), n)) : xe = n);
}, Tr = () => ({
  getPrefixCls: (t, e) => e || (t ? `${M()}-${t}` : M()),
  getIconPrefixCls: Er,
  getRootPrefixCls: () => T || M(),
  getTheme: () => xe,
  holderRender: Oe
}), $r = (t) => {
  const {
    children: e,
    csp: r,
    autoInsertSpaceInButton: n,
    alert: i,
    anchor: c,
    form: o,
    locale: s,
    componentSize: d,
    direction: a,
    space: f,
    splitter: p,
    virtual: b,
    dropdownMatchSelectWidth: O,
    popupMatchSelectWidth: P,
    popupOverflow: Se,
    legacyLocale: Ee,
    parentContext: S,
    iconPrefixCls: we,
    theme: H,
    componentDisabled: Q,
    segmented: je,
    statistic: $e,
    spin: _e,
    calendar: ke,
    carousel: Ne,
    cascader: Ve,
    collapse: Me,
    typography: Ae,
    checkbox: Te,
    descriptions: De,
    divider: Re,
    drawer: Ie,
    skeleton: Le,
    steps: We,
    image: Fe,
    layout: Ye,
    list: Ke,
    mentions: ze,
    modal: qe,
    progress: Ue,
    result: Be,
    slider: Ge,
    breadcrumb: He,
    menu: Qe,
    pagination: Xe,
    input: Ze,
    textArea: Je,
    empty: et,
    badge: tt,
    radio: rt,
    rate: nt,
    switch: ot,
    transfer: at,
    avatar: st,
    message: it,
    tag: lt,
    table: ct,
    card: dt,
    tabs: ut,
    timeline: ft,
    timePicker: mt,
    upload: gt,
    notification: pt,
    tree: vt,
    colorPicker: bt,
    datePicker: ht,
    rangePicker: Ct,
    flex: yt,
    wave: Pt,
    dropdown: xt,
    warning: Ot,
    tour: St,
    tooltip: Et,
    popover: wt,
    popconfirm: jt,
    floatButtonGroup: $t,
    variant: _t,
    inputNumber: kt,
    treeSelect: Nt
  } = t, X = l.useCallback((u, g) => {
    const {
      prefixCls: h
    } = t;
    if (g)
      return g;
    const C = h || S.getPrefixCls("");
    return u ? `${C}-${u}` : C;
  }, [S.getPrefixCls, t.prefixCls]), j = we || S.iconPrefixCls || ge, $ = r || S.csp;
  vr(j, $);
  const _ = yr(H, S.theme, {
    prefixCls: X("")
  });
  process.env.NODE_ENV !== "production" && (U = U || !!_);
  const L = {
    csp: $,
    autoInsertSpaceInButton: n,
    alert: i,
    anchor: c,
    locale: s || Ee,
    direction: a,
    space: f,
    splitter: p,
    virtual: b,
    popupMatchSelectWidth: P ?? O,
    popupOverflow: Se,
    getPrefixCls: X,
    iconPrefixCls: j,
    theme: _,
    segmented: je,
    statistic: $e,
    spin: _e,
    calendar: ke,
    carousel: Ne,
    cascader: Ve,
    collapse: Me,
    typography: Ae,
    checkbox: Te,
    descriptions: De,
    divider: Re,
    drawer: Ie,
    skeleton: Le,
    steps: We,
    image: Fe,
    input: Ze,
    textArea: Je,
    layout: Ye,
    list: Ke,
    mentions: ze,
    modal: qe,
    progress: Ue,
    result: Be,
    slider: Ge,
    breadcrumb: He,
    menu: Qe,
    pagination: Xe,
    empty: et,
    badge: tt,
    radio: rt,
    rate: nt,
    switch: ot,
    transfer: at,
    avatar: st,
    message: it,
    tag: lt,
    table: ct,
    card: dt,
    tabs: ut,
    timeline: ft,
    timePicker: mt,
    upload: gt,
    notification: pt,
    tree: vt,
    colorPicker: bt,
    datePicker: ht,
    rangePicker: Ct,
    flex: yt,
    wave: Pt,
    dropdown: xt,
    warning: Ot,
    tour: St,
    tooltip: Et,
    popover: wt,
    popconfirm: jt,
    floatButtonGroup: $t,
    variant: _t,
    inputNumber: kt,
    treeSelect: Nt
  };
  process.env.NODE_ENV !== "production" && D("ConfigProvider")(!("autoInsertSpaceInButton" in t), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
  const E = Object.assign({}, S);
  Object.keys(L).forEach((u) => {
    L[u] !== void 0 && (E[u] = L[u]);
  }), Sr.forEach((u) => {
    const g = t[u];
    g && (E[u] = g);
  }), typeof n < "u" && (E.button = Object.assign({
    autoInsertSpace: n
  }, E.button));
  const w = me(() => E, E, (u, g) => {
    const h = Object.keys(u), C = Object.keys(g);
    return h.length !== C.length || h.some((k) => u[k] !== g[k]);
  }), {
    layer: Z
  } = l.useContext(Bt), Vt = l.useMemo(() => ({
    prefixCls: j,
    csp: $,
    layer: Z ? "antd" : void 0
  }), [j, $, Z]);
  let m = /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(xr, {
    dropdownMatchSelectWidth: O
  }), e);
  const J = l.useMemo(() => {
    var u, g, h, C;
    return ar(((u = I.Form) === null || u === void 0 ? void 0 : u.defaultValidateMessages) || {}, ((h = (g = w.locale) === null || g === void 0 ? void 0 : g.Form) === null || h === void 0 ? void 0 : h.defaultValidateMessages) || {}, ((C = w.form) === null || C === void 0 ? void 0 : C.validateMessages) || {}, (o == null ? void 0 : o.validateMessages) || {});
  }, [w, o == null ? void 0 : o.validateMessages]);
  Object.keys(J).length > 0 && (m = /* @__PURE__ */ l.createElement(sr.Provider, {
    value: J
  }, m)), s && (m = /* @__PURE__ */ l.createElement(Ce, {
    locale: s,
    _ANT_MARK__: he
  }, m)), (j || $) && (m = /* @__PURE__ */ l.createElement(Zt.Provider, {
    value: Vt
  }, m)), d && (m = /* @__PURE__ */ l.createElement(er, {
    size: d
  }, m)), m = /* @__PURE__ */ l.createElement(Pr, null, m);
  const Mt = l.useMemo(() => {
    const u = _ || {}, {
      algorithm: g,
      token: h,
      components: C,
      cssVar: k
    } = u, At = Or(u, ["algorithm", "token", "components", "cssVar"]), ee = g && (!Array.isArray(g) || g.length > 0) ? ae(g) : Gt, W = {};
    Object.entries(C || {}).forEach(([Tt, Dt]) => {
      const y = Object.assign({}, Dt);
      "algorithm" in y && (y.algorithm === !0 ? y.theme = ee : (Array.isArray(y.algorithm) || typeof y.algorithm == "function") && (y.theme = ae(y.algorithm)), delete y.algorithm), W[Tt] = y;
    });
    const te = Object.assign(Object.assign({}, Ht), h);
    return Object.assign(Object.assign({}, At), {
      theme: ee,
      token: te,
      components: W,
      override: Object.assign({
        override: te
      }, W),
      cssVar: k
    });
  }, [_]);
  return H && (m = /* @__PURE__ */ l.createElement(Qt.Provider, {
    value: Mt
  }, m)), w.warning && (m = /* @__PURE__ */ l.createElement(Jt.Provider, {
    value: w.warning
  }, m)), Q !== void 0 && (m = /* @__PURE__ */ l.createElement(gr, {
    disabled: Q
  }, m)), /* @__PURE__ */ l.createElement(B.Provider, {
    value: w
  }, m);
}, x = (t) => {
  const e = l.useContext(B), r = l.useContext(be);
  return /* @__PURE__ */ l.createElement($r, Object.assign({
    parentContext: e,
    legacyLocale: r
  }, t));
};
x.ConfigContext = B;
x.SizeContext = G;
x.config = jr;
x.useConfig = pr;
Object.defineProperty(x, "SizeContext", {
  get: () => (process.env.NODE_ENV !== "production" && R(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), G)
});
process.env.NODE_ENV !== "production" && (x.displayName = "ConfigProvider");
const Dr = x;
export {
  Dr as C,
  q as D,
  be as L,
  sr as V,
  rr as _,
  gr as a,
  Mr as b,
  Tr as c,
  ie as d,
  ir as e,
  z as g,
  tr as i,
  I as l,
  ar as m,
  Y as s,
  Ar as w
};
